import DataMapper from './../DataMapper'
import DoctorPathologistsDataRM from '../../responsemodel/CaseServiceDataRM/DoctorPathologistsDataRM'
import DoctorPathologistsData from "../../../models/CaseServiceData/DoctorPathologistsData"
class DoctorPathologistsDataMapper extends DataMapper<DoctorPathologistsDataRM, DoctorPathologistsData> {
    map = (rm: DoctorPathologistsDataRM) => new DoctorPathologistsData(rm.contactNumber, rm.doctorAvailableInHospital, rm.doctorConfirmation, rm.hospitalData, rm.investigatorName, rm.isFieldSaved, rm.pathologistName, rm.personalMeeting, rm.personalMeetingPic, rm.qualification, rm.registrationCertificate, rm.registrationNumber)
}
export default DoctorPathologistsDataMapper
